import React from "react";
import { styled } from "@mui/material/styles";
import { Carousel } from "react-responsive-carousel";
import { Switch, Alert, Stack, Paper, Button, Box, Typography, Dialog } from "@mui/material";

export const StyledCarousel = styled(({ className, ...props }) => <Carousel {...props} className={`${className} control-dots`} />)(({ theme }) => ({
  "& .control-arrow:before": {
    color: "#343a40", // 원하는 색상으로 변경
  },
  "& .control-dots": {
    position: "absolute",
    bottom: "-10px",
    zIndex: 1,
  },
  "& .control-dots .dot": {
    background: "#6c757d",
    margin: "0 5px", // dot 간격 조절
  },
  "& .control-dots .dot.selected": {
    background: "#343a40",
  },
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "6px",
  padding: "6px 12px",
  fontWeight: "bold",
  fontSize: "14px",
  lineHeight: "20px",
  textTransform: "none",
  color: "#fff",
  backgroundColor: "#1565C0",
  "&:hover": {
    backgroundColor: "#1E88E5",
  },
  "&:active": {
    backgroundColor: "#0D47A1",
  },
  "&:focus": {
    backgroundColor: "#64B5F6",
  },
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "5px",
  marginBottom: "5px",
  backgroundColor: "#f2f2f2",
  borderRadius: "6px 6px 6px 6px",
  borderBottom: "1px solid #ddd",
}));

export const StyledTypo = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  color: "#333",
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    overflowY: "unset",
    minWidth: "1800px",
    width: "100%",
    height: "80%",
    margin: "auto",
  },
}));

export const DropArea = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  border: "1px dashed #CFCFCF",
  borderRadius: 4,
  minHeight: 200,
  position: "relative",
});

export const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&:before, &:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&:before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(theme.palette.getContrastText(theme.palette.primary.main))}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&:after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(theme.palette.getContrastText(theme.palette.primary.main))}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export function CustomAlert({ message, severity }) {
  return (
    <>
      <Stack sx={{ width: "100%" }} spacing={2}>
        <Alert severity={severity}>{message}</Alert>
      </Stack>
    </>
  );
}
